<div *ngIf="items$ | async as items; else loading">
  <div *ngFor="let item of items; trackBy: trackByFn">
    <div *ngIf="item.subItems.length > 0" class="accordion accordion-bordered mb-5">
      <button
        class="accordion-button pl-4 pr-9"
        (click)="toggleExpand(item)"
        [attr.aria-expanded]="!!expandedItemIds[item.title]"
      >
        <div class="mb-3 mt-0">
          <h3>{{ item.title }}</h3>
          <bom-info-icon
            *ngIf="item.showInfoIcon"
            (invokedEvent)="clickInfoIcon.emit(item)"
            [content$]="(infos$ | async)[item.id]"
          ></bom-info-icon>
        </div>
        <p class="my-0" [innerHTML]="item.description"></p>
      </button>
      <div class="accordion-content p-5" [attr.aria-hidden]="!expandedItemIds[item.title]">
        <div *ngFor="let subItem of item.subItems; let lastItem = last; trackBy: trackByFn">
          <bom-hierarchy-item
            [item]="subItem"
            [addedItemIds$]="addedItemIds$"
            [isAddDisabled$]="isAddDisabled$"
            [infos$]="infos$"
            [addButtonTextKey]="addButtonTextKey"
            (clickAdd)="clickAdd.emit($event)"
            (clickInfoIcon)="clickInfoIcon.emit($event)"
          ></bom-hierarchy-item>
          <div *ngIf="!lastItem" class="inner-border-example my-5"></div>
        </div>
      </div>
    </div>

    <div *ngIf="item.subItems.length === 0" class="card mb-5 test-activity-type-card">
      <div class="card-text">
        <bom-hierarchy-item
          [item]="item"
          [addedItemIds$]="addedItemIds$"
          [isAddDisabled$]="isAddDisabled$"
          [infos$]="infos$"
          [addButtonTextKey]="addButtonTextKey"
          (clickAdd)="clickAdd.emit($event)"
          (clickInfoIcon)="clickInfoIcon.emit($event)"
        ></bom-hierarchy-item>
      </div>
    </div>
  </div>
</div>

<ng-template #loading><bom-spinner></bom-spinner></ng-template>
